export const iso3ToIso2 = (countryCode: string) => {
  switch (countryCode?.toUpperCase()) {
    case 'EGY':
      return 'eg';
    case 'ARE':
      return 'ae';
    case 'SAU':
      return 'sa';
    case 'OMN':
      return 'om';
    case 'PAK':
      return 'pk';
    default:
      return 'eg'
  }
};

export const iso2ToIso3 = (countryCode: string) => {
  switch (countryCode?.toUpperCase()) {
    case 'EG':
      return 'EGY';
    case 'AE':
      return 'ARE';
    case 'SA':
      return 'SAU';
    case 'OM':
      return 'OMN';
    case 'PK':
      return 'PAK';
    default:
      return 'EGY';
  }
};